import React from 'react'
import PropTypes  from 'prop-types'
function Card(props) {
    return (
        <div>
            <div className={`card bg-dark text-${props.mode==='light'?'black':'white'} `}>
                <img src={`${props.mode==='light'?'stephen-leonardi-N6duvHcGrR4-unsplash.jpg':'anthony-cantin-S4u2_o3i3Ws-unsplash.jpg'}`} className="card-img" alt=""
                height={"500px"}/>
                <div className="card-img-overlay ">
                    <h1 className="card-title text-center pdown">The place where you get more</h1>
                    <div className="text-center">
                    <button type="button" className={`btn btn-${props.mode==='light'?'dark':'light'} col justify-content-center`}>Go Explore</button>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Card
